import { DeleteModal } from "@/components/modal/DeleteModal.tsx";
import { DiskDeleteWarning } from "@/modules/compute/DiskDeleteModal.tsx";
import type { DeleteDiskMutation } from "@/modules/disks/disk/DiskView.tsx";
import type { DiskWithPrice } from "@/modules/disks/disksListQuery.ts";

export function DiskDeleteModal({
    item,
    isDisabled,
    deleteMutation,
}: {
    item: DiskWithPrice;
    isDisabled?: boolean;
    deleteMutation: DeleteDiskMutation;
}) {
    const { location, uuid } = item;

    async function onDelete() {
        await deleteMutation.mutateAsync({ location, uuid });
    }

    return (
        <DeleteModal isDisabled={isDisabled} modalAction={async () => await onDelete()}>
            <DiskDeleteWarning />
        </DeleteModal>
    );
}
